import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "wechat/";

// 获取绑定微信二维码
export const getBindQrCode = params => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "getBindQrCode", {
           data: _params,
           method: "GET"
         });
       };
// 获取微信授权登录二维码
export const getLoginQrCode = params => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "getLoginQrCode", {
           data: _params,
           method: "GET"
         });
       };
// 检查状态（轮询接口）
export const checkStatus = params => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "checkStatus", {
           data: _params,
           isWarning: false,
           method: "GET"
         });
       };

// 解除绑定微信
export const unBind = params => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "unBind", {
           data: _params,
           method: "POST"
         });
       };



// WEBPACK FOOTER //
// ./src/fetch/api/bindWx.js